import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Chip,
  Grid,
  Box,
  IconButton
} from '@mui/material';
import {
  LocationOn,
  Phone,
  Email,
  Edit,
  Store,
  Inventory,
  AttachMoney,
  People,
  TrendingUp
} from '@mui/icons-material';

const LocationCard = ({ location, onEdit }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate(`/locations/${location.id}`);
  };

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <Box>
            <Typography variant="h6" gutterBottom>
              {location.name}
            </Typography>
            <Chip
              label={location.status === 'active' ? 'Active' : 'Inactive'}
              color={location.status === 'active' ? 'success' : 'default'}
              size="small"
            />
          </Box>
          {onEdit && (
            <IconButton size="small" onClick={() => onEdit(location)}>
              <Edit />
            </IconButton>
          )}
        </Box>

        <Box display="flex" alignItems="center" mb={1}>
          <LocationOn fontSize="small" color="action" sx={{ mr: 1 }} />
          <Typography variant="body2" color="text.secondary">
            {location.full_address}
          </Typography>
        </Box>

        {location.phone && (
          <Box display="flex" alignItems="center" mb={1}>
            <Phone fontSize="small" color="action" sx={{ mr: 1 }} />
            <Typography variant="body2" color="text.secondary">
              {location.phone}
            </Typography>
          </Box>
        )}

        {location.email && (
          <Box display="flex" alignItems="center" mb={2}>
            <Email fontSize="small" color="action" sx={{ mr: 1 }} />
            <Typography variant="body2" color="text.secondary">
              {location.email}
            </Typography>
          </Box>
        )}

        {location.manager && (
          <Box mb={2}>
            <Typography variant="caption" color="text.secondary">
              Manager
            </Typography>
            <Typography variant="body2">
              {location.manager.name}
            </Typography>
          </Box>
        )}

        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={6}>
            <Box display="flex" alignItems="center">
              <Store fontSize="small" color="primary" sx={{ mr: 0.5 }} />
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Sales
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {location.sales_count || 0}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box display="flex" alignItems="center">
              <Inventory fontSize="small" color="secondary" sx={{ mr: 0.5 }} />
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Inventory
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {location.inventory_count || 0}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box display="flex" alignItems="center">
              <TrendingUp fontSize="small" color="success" sx={{ mr: 0.5 }} />
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Leads
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {location.leads_count || 0}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box display="flex" alignItems="center">
              <People fontSize="small" color="info" sx={{ mr: 0.5 }} />
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Staff
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {location.staff_count || 0}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CardContent>

      <CardActions>
        <Button size="small" onClick={handleViewDetails}>
          View Details
        </Button>
      </CardActions>
    </Card>
  );
};

export default LocationCard;
